import { Outlet } from 'react-router'
import './styles.scss'

export const LayoutHome = () => {

  return (
    <div className='home-wrapper'>
      <Outlet />
    </div>
  )
}